import { render } from "./SimplePrice.vue?vue&type=template&id=216d1dd7&lang=pug"
import script from "./SimplePrice.vue?vue&type=script&lang=js"
export * from "./SimplePrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__